import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { find as _find } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';

import { getNameInCurrentLanguage } from 'helpers/intl';

import FormAutocomplete from 'components/forms/FormAutocomplete';

import SimplePrompt from 'components/layout/SimplePrompt';
import Loader from 'components/layout/Loader';
import List from 'components/List';

import { ROLE_ERP_MASTER } from 'js/constants';
import may from 'js/security';

class AttributeCategories extends React.Component {
  addCategory = categoryId => {
    const {
      intl: { messages },
      entity,
      addAttributesCategory,
      attributeCategories,
      doNotify,
    } = this.props;

    if (_find(attributeCategories.data.list, ['id', categoryId])) {
      doNotify(0, messages.category_already_in_attribute);
      return;
    }

    addAttributesCategory(entity.getId(), categoryId);
    doNotify(1, messages.attribute_saved);
  };

  handleRemoveClick = (e, categoryId) => {
    e.preventDefault();
    e.stopPropagation();

    const {
      intl: { messages },
      entity,
      deleteAttributesCategory,
      doNotify,
    } = this.props;

    deleteAttributesCategory(entity.getId(), categoryId);

    doNotify(1, messages.attribute_saved);
  };

  getCategoriesBody = () => {
    const { appIntl, user, attributeCategories } = this.props;

    return attributeCategories.data.list.map((category, i) => {
      return (
        <tr key={category.id} className={i % 2 ? 'even ' : 'odd '}>
          <td className="v-align-middle semi-bold">{getNameInCurrentLanguage(category.name, appIntl)}</td>
          <td className="v-align-middle text-right">
            {may(ROLE_ERP_MASTER, user.roles) && (
              <SimplePrompt
                onSuccess={e => {
                  this.handleRemoveClick(e, category.id);
                }}
              />
            )}
          </td>
        </tr>
      );
    });
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      attributeCategories,
    } = this.props;

    const columns = [messages.name, messages.actions];

    return (
      <div className="clearfix">
        {entityLoaded && (
          <div className="padding-20 sm-padding-10">
            <List noRender listName="attributeCategories" url={`/api/attributes/${entity.getId()}/categories.json`} />

            {attributeCategories.pending ? (
              <Loader />
            ) : (
              <>
                <Row>
                  <Col xs={12} sm={6} md={4}>
                    <div className="form-group-attached">
                      <FormAutocomplete
                        returnValueObject
                        label={messages.select_category}
                        name="category"
                        onChange={(property, value) => {
                          this.addCategory(value.id);
                        }}
                        autocompleteType="category"
                        complete
                        disabled={disabled}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <Table responsive hover>
                      <thead>
                        <tr>
                          {columns.map((column, i) => {
                            return (
                              <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                                {column}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <ReactCSSTransitionGroup
                        transitionName="tablerows"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={1}
                        component="tbody"
                      >
                        {this.getCategoriesBody()}
                      </ReactCSSTransitionGroup>
                    </Table>
                  </Col>
                </Row>
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    attributeCategories: state.list.attributeCategories,
    appIntl: state.intl,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteAttributesCategory: (attributeId, categoryId) => {
      deleterDispatchHelper(
        'attributeCategories',
        '/api/attributes/' + attributeId + '/categories/' + categoryId + '.json',
        dispatch
      );
    },
    addAttributesCategory: (attributeId, categoryId) => {
      formStatusDispatchHelper(
        'attributeCategories',
        '/api/attributes/' + attributeId + '/categories/' + categoryId + '.json',
        null,
        'put',
        dispatch
      );
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AttributeCategories)
);
